import React, { useEffect, useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { ActiveRoleContext, hasAssignedRole, getActiveRole, setActiveRole } from "@/utils/activeRole";

// Membungkus halaman satu role (mis. /marketing/*). Kalau akun ini punya role itu
// sebagai role TAMBAHAN, selama berada di dalam pembungkus ini akun bekerja sebagai
// role tersebut. Untuk akun yang role utamanya memang itu, tidak ada yang berubah.
export default function ActiveRoleBoundary({ role, children }) {
  const { user } = useAuth(); // di luar konteks override, jadi ini user asli
  const eligible = hasAssignedRole(user, role);

  // Diset saat render supaya request pertama anak-anaknya sudah membawa header.
  if (eligible) setActiveRole(role);

  useEffect(() => () => {
    if (getActiveRole() === role) setActiveRole(null);
  }, [role]);

  const value = useMemo(() => (eligible ? role : null), [eligible, role]);
  return <ActiveRoleContext.Provider value={value}>{children}</ActiveRoleContext.Provider>;
}
